import {useQuery} from "@apollo/client";

import {
    VoucherClearingLogListResponse,
    GET_VOUCHER_CLEARING_LOG_LISTING
} from "../graphql/queries/getVoucherClearingLogList";


import {useEffect, useState} from "react";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";
import {VoucherClearingLogFilterType, VoucherClearingLogType} from "../graphql/types/VoucherClearingLogType";

export interface VoucherClearingLogQueryResult {
    voucherClearingLogData: VoucherClearingLogType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useVoucherClearingLogQuery = (
    filters: VoucherClearingLogFilterType,
    currentPage: number,
    pageSize: number
): VoucherClearingLogQueryResult => {
    const [voucherClearingLogData, setVoucherClearingLogData] = useState<VoucherClearingLogType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {

        const timeRanges = {
            createdAt : formatTimeRangeToISO(filters.createdAt),
        };
        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<VoucherClearingLogListResponse>(GET_VOUCHER_CLEARING_LOG_LISTING,
        {variables: buildQueryVariables()});

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getVoucherClearingLogPageable?.content;
        if (responseData) {
            setVoucherClearingLogData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getVoucherClearingLogPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        voucherClearingLogData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
}; 